import React from "react";
import "./About.scss";
import binance1 from "../../assets/images/binance.png";
const About = ({ details }) => {
  return (
    <div style={{ width: "100%" }}>
      <div className="row about" style={{ alignItems: "center" }}>
        {details.cc_meta_data == undefined ? (
          ""
        ) : (
          <>
            {/* <div className="col-12 col-md-4" style={{ textAlign: "center" }}>
            </div> */}
            <div className="col-12 col-md-7 mx-auto">
              <div className="name">
                درباره {details.cc_meta_data.farsi_name}
                {" "}
              <img src={details.cc_meta_data.logo} alt="آیکون" />
                <hr />
              </div>
              <div>{details.cc_meta_data.Farsi_description}</div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default About;
